import { isMobile } from 'react-device-detect';
import { Term } from 'useCases/service-terms';
import { usePortal } from 'hooks';
import { Heading, Icon } from 'components/structure';
import * as S from './Terms.styles';

export type TermsProps = {
  show: boolean;
  onConfirm: () => void;
  term?: Term;
};

const Terms = ({ show = false, term = {} as Term, onConfirm }: TermsProps) => {
  const Portal = usePortal();

  if (isMobile && show) {
    term?.name === 'POLÍTICA DE PRIVACIDADE'
      ? window.open(
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/Poli%CC%81tica+Privacidade+AMPRO+2025.docx.pdf',
          '_blank',
        )
      : window.open(
          'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/Termos+de+Uso+AMPRO+2025.docx.pdf',
          '_blank',
        );
    onConfirm();
  }

  // if (isMobile && show) {
  //   window.open(term.url, '_blank');
  //   onConfirm();
  // }

  return show ? (
    <Portal>
      <S.Wrapper show={show}>
        <S.BoxTerms>
          <S.Header>
            <S.IconWrapper show={show} onClick={onConfirm}>
              <Icon color="black" icon="IcClose" />
            </S.IconWrapper>
          </S.Header>
          <S.Content>
            <Heading dark center>
              {term.name}
            </Heading>
            {/* <S.Document data={term.url} type="text/html" /> */}
            <S.Document
              data={
                term.name === 'POLÍTICA DE PRIVACIDADE'
                  ? 'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/Poli%CC%81tica+Privacidade+AMPRO+2025.docx.pdf'
                  : 'https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/Termos+de+Uso+AMPRO+2025.docx.pdf'
              }
              type="text/html"
            />
          </S.Content>
        </S.BoxTerms>
      </S.Wrapper>
    </Portal>
  ) : (
    <></>
  );
};

export { Terms };
